import { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { siteboardAction } from '../actions/defaultActions';
import { SET_UPGRADE_TO_STANDARD_DIALOGUE_OPEN } from '../actions/types';
import PopupWindow from './PopupWindow';
import SubscriptionPaymentCard from './SubscriptionPaymentCard';

import ChecklistIcon from '../icons/checklistIcon';

const UpgradeToStandardSubscriptionDialogue = ({ _users, _userId, _subscriptions, siteboardAction }) => {

  let alreadyHasStandardSubscription = false;
  try {
    const ownedSubscription = _subscriptions[_users[_userId].ownedSubscriptionId];
    alreadyHasStandardSubscription = ownedSubscription.type === 'Standard';
  } catch(error) {}

  const closeDialogue = () => {
    siteboardAction(SET_UPGRADE_TO_STANDARD_DIALOGUE_OPEN, { isOpen: false });
  };

  return (
    <PopupWindow title={`Subscribe to ${process.env.REACT_APP_WEBSITE_NAME}`} closeDialogue={closeDialogue} bgStyle='bg-[#333333]'>
      <div className='flex flex-col gap-y-6 max-w-screen-sm text-white'>
        {!alreadyHasStandardSubscription && 
          <>
            {/*<div className='flex gap-2'>
              <ChecklistIcon size='16' color='#55fa79' />
              <div>Allows for unlimited projects and schedules</div>
            </div>*/}
            <SubscriptionPaymentCard />
          </>
        }
        {alreadyHasStandardSubscription && 
          <>
            <div className='min-w-[400px]'></div>
            <div>
              You already have a Standard subscription.
            </div>
          </>
        }
      </div>
    </PopupWindow>
  );
};


const mapStateToProps = state => { return { // define redux state that will be passed in as props
  _users: state.serverSynced.users,
  _userId: state.localPersistent.userId,
  _subscriptions: state.serverSynced.subscriptions,
}};
export default connect(mapStateToProps, { siteboardAction })(UpgradeToStandardSubscriptionDialogue);
